// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__cF-li","label":"Labeled_label__3tntc","divider":"Labeled_divider__1hXDF"};